import { createOpenStore, type ColumnDialogOpen } from "stores/createOpenStore";

export const useSearchReplaceStore = createOpenStore<ColumnDialogOpen>();
